import React, { Component } from "react";
import Simplefooter from "../footer/simplefooter";
import data from "../../mock/workshops-mock.json";
import CalendarCustom from "./customCalendar";
// import Schedule from '../schedule/scheduleContent'
import dataSchedule from "../../mock/schedule-mock.json";
import Modal from "../utils/modal";
import * as emailjs from "emailjs-com";
import Reservation from "./reservation";
import Warnme from "../workshop/warnme";

//
import mul1 from "../../assets/banners/courses/Workshop_Bitcoin.png";
import mob1 from "../../assets/banners/courses/Workshop_Bitcoin.png";

import mul2 from "../../assets/banners/courses/Datas_Arqui_Integracao.png";
import mob2 from "../../assets/banners/courses/Datas_Arqui_Integracao.png";

import mul3 from "../../assets/banners/courses/Data_Implementacao_de_Microservices.png";
import mob3 from "../../assets/banners/courses/Data_Implementacao_de_Microservices.png";

import mul4 from "../../assets/Curso_img/splint/Banner_Togaf.png";
// import mob4 from '../../assets/Curso_img/splint/Mobile_Togaf.png'

import mul5 from "../../assets/banners/courses/Data_Business_Trends.png";
import mob5 from "../../assets/banners/courses/Data_Business_Trends.png";

import mul6 from "../../assets/banners/courses/Workshop_Inteligencia_Competitiva.png";
import mob6 from "../../assets/banners/courses/Carrosel_Inteligencia_Competitiva.png";

import mul7 from "../../assets/banners/courses/ApiForBusiness/datasAPI.png";
import mob7 from "../../assets/banners/courses/ApiForBusiness/mobile workshop.png";

import mul8 from "../../assets/banners/courses/Workshop_A_COMMERCE.png";
import mob8 from "../../assets/banners/courses/Workshop_A_COMMERCE.png";

import mul9 from "../../assets/Curso_img/splint/Banner_Blockchain.png";
import mob9 from "../../assets/Curso_img/splint/Mobile_Blockchain.png";

import mul12 from "../../assets/banners/courses/Data_COMO_MONTAR_SUA_STARTUP.png";
import mob12 from "../../assets/banners/courses/Mobile_Carrosel_e_Workshop_COMO_MONTAR_SUA_STARTUP.png";

import mul13 from "../../assets/banners/courses/Cloud/Banner_cloud.png";
import mob13 from "../../assets/banners/courses/Cloud/mobile_cloud.png";

import mul14 from "../../assets/banners/courses/Datas_Cybersecurity_com_Solucoes_Open_Source.png";
import mob14 from "../../assets/banners/courses/Mobile_Carrosel_e_Workshop_Cybersecurity_com_Solucoes_Open_Source.png";

import mul15 from "../../assets/banners/courses/dataAnalytics/Data_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png";
import mob15 from "../../assets/banners/courses/dataAnalytics/Mobile_DATA_ANALYTICS_DOS_DADOS_AOS_INSIGTHS.png";

import mul16 from "../../assets/banners/courses/aplicMoveis/Datas_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";
import mob16 from "../../assets/banners/courses/aplicMoveis/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";

import mul17 from "../../assets/banners/courses/Chatbots_crm/Banner_chatbots.png";
import mob17 from "../../assets/banners/courses/Chatbots_crm/mobile_chatbots.png";

import mul18 from "../../assets/banners/courses/DesenvolvimentoTI/banner_desenvolvimento_ti.png";
import mob18 from "../../assets/banners/courses/aplicMoveis/Mobile_Carrosel_e_Workshop_DESENVOLVIMENTO_APLICACOES_MOVEIS.png";

import mul19 from "../../assets/banners/courses/arquiDesenBlockchain/Workshop_ARQUI._E_DESEN._EM_BLOCKCHAIN.png";

import mul20 from "../../assets/banners/courses/AplJogos/Data_APLICACOES_EJOGOS-09.png";
import mob20 from "../../assets/banners/courses/AplJogos/Data_APLICACOES_EJOGOS-09.png";

import mul21 from "../../assets/banners/courses/dashboardAnalytics/PC_Workshop_e_Data_DASHBOARD_E_ANALYTICS.png";
import mob21 from "../../assets/banners/courses/dashboardAnalytics/Mobile_Data_DASHBOARD_E_ANALYTICS.png";

import mul22 from "../../assets/banners/courses/designThings/Workshop_DESIGN_THINKING.png";
import mob22 from "../../assets/banners/courses/designThings/Workshop_DESIGN_THINKING.png";

import mul23 from "../../assets/banners/courses/InternetOfThings/Data_INTERNET_OF_THING_E_SENSORIZACAO.png";
import mob23 from "../../assets/banners/courses/InternetOfThings/Mobile_Carrosel_INTERNET_OF_THING_E_SENSORIZACAO (1).png";

import mul24 from "../../assets/banners/courses/desenvolvendoApis/workshop_data_pc.png";
import mob24 from "../../assets/banners/courses/desenvolvendoApis/mobile_data.png";

import mul25 from "../../assets/banners/courses/Intel_em_Cybersecurity/PC_Data.png";
import mob25 from "../../assets/banners/courses/Intel_em_Cybersecurity/Mobile_Data_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-13.png";

import mul26 from "../../assets/banners/courses/NoSQL/Banner_NOSQL.png";
import mob26 from "../../assets/banners/courses/NoSQL/Mobile_NOSQL.png";

import mul27 from "../../assets/banners/courses/Storytelling/PC_Data_STORYTELLING_E_UX_PARA_NEGOCIOS.png";
import mob27 from "../../assets/banners/courses/Storytelling/Mobile_Data_STORYTELLING_E_UX_PARA_NEGOCIOS-13.png";

import mul28 from "../../assets/banners/courses/APIGATEWAY/desc_Banner_Data_API_GATEWAY-06-06.png";
import mob28 from "../../assets/banners/courses/APIGATEWAY/Mobile_Data_API_GATEWAY.png";

import mul29 from "../../assets/banners/courses/agilidade/PC_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI.png";
import mob29 from "../../assets/banners/courses/agilidade/Mobile_Data_AGILIDADE_DEVOPS_E_PERFORMANCE_EM_TI-13.png";

import mul30 from "../../assets/banners/courses/acoes/Data_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png";
import mob30 from "../../assets/banners/courses/acoes/Mobile_Workshop_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png";

import mul31 from "../../assets/banners/courses/design_sprint/PC_Carrosel_DESIGN_SPRINT.png";
import mob31 from "../../assets/banners/courses/design_sprint/Mobile_Data_DESIGN_SPRINT.png";

import mul32 from "../../assets/banners/courses/ethical hacking/PC_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png";
import mob32 from "../../assets/banners/courses/ethical hacking/Mobile_Data_ETHICAL_HACKING_METOLOGIA_DE_PENTEST.png";

import mul33 from "../../assets/banners/courses/desenvolvimentoArq/PC_Workshop_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png";
import mob33 from "../../assets/banners/courses/desenvolvimentoArq/Mobile_Data_DESENVOLVIMENTO_DE_ARQ._DE_INTEG._COM_APACHE_E_KAFKA_SERVICE.png";

import mul34 from "../../assets/banners/courses/ibm/PC_Workshop_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png";
import mob34 from "../../assets/banners/courses/ibm/Mobile_Data_IBM_WATSON_E_CHATBOTS_INTELIGENTES_COM_COGNIFICACAO.png";

import mul35 from "../../assets/banners/courses/desWebFullStack/PC_Data_Desenvolvimento_Web_Full_Stack.png";
import mob35 from "../../assets/banners/courses/desWebFullStack/Mobile_Data_Desenvolvimento_Web_Full_Stack.png";

import mul36 from "../../assets/banners/courses/intelCyberEthical/PC_Wokshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING.png";
import mob36 from "../../assets/banners/courses/intelCyberEthical/Mobile_Workshop_INTELIGENCIA_EM_CYBERSECURITY_COM_ETHICAL_HACKING (1).png";

import mul37 from "../../assets/banners/courses/gestao_proj/PC_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_EFICAZ_USANDO_PMI.png";
import mob37 from "../../assets/banners/courses/gestao_proj/Mobile_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_E_EFICAZ_USANDO_PMI.png";

import mul38 from "../../assets/banners/courses/prep_cert/new_PREPARATORIO_PARA_CERTIFICACAO_ITIL_E_COBIT-06.png";
import mob38 from "../../assets/banners/courses/prep_cert/Mobile_Data_PREPARATÓRIO_PARA_CERTIFICAÇÃO_ITIL_E_COBIT.png";

import mul39 from "../../assets/banners/courses/fundamentos-devops/PC_Carrosel_FUNDAMENTOS_DE_DEVOPS.png";
import mob39 from "../../assets/banners/courses/fundamentos-devops/Moible_Data_FUNDAMENTOS_DE_DEVOPS.png";

import mul40 from "../../assets/banners/courses/arq_infra/PC_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png";
import mob40 from "../../assets/banners/courses/arq_infra/Mobile_Data_ARQUITETURA_DE_INFRAESTRUTURA_CORPORATIVA_DE_TI.png";

import mul41 from "../../assets/banners/courses/bigData_Mining/PC_Data_e_Wokshop_BIG_DATA_E_DATA_MINING.png";
import mob41 from "../../assets/banners/courses/bigData_Mining/Mobile_Data_BIG_DATA_E_DATA_MINING.png";

import mul42 from "../../assets/banners/courses/governanca/PC_Workshop_GOVERNANCA_CORPORATIVA_E_TI.png";
import mob42 from "../../assets/banners/courses/governanca/Mobile_Data_GOVERNANCA_CORPORATIVA_E_TI.png";

import mul43 from "../../assets/banners/courses/golangdesenv/desc_banner_data_Golang-06.png";
import mob43 from "../../assets/banners/courses/golangdesenv/MobileDataGOLANGDESENDESISTEMASCOMMICROSERVICES.png";

import mul44 from "../../assets/banners/courses/microservice/MICROSERVICE_USANDO_STREAMING_PARA_BIGDATA_-_KAFKA_NODEJS_GO_GCP-06.png";
import mob44 from "../../assets/banners/courses/microservice/MobileWorkshopMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.png";

import mul45 from "../../assets/banners/courses/praticando/DESC_PRATICANDO_ARQUITETURA_DE_INTEGRACAO_COM_APACHE_KAFKA_SERVICE_MESH_ISTIO_API_E_MONGODB-06.png";
import mob45 from "../../assets/banners/courses/praticando/MobileDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.png";

import mul46 from "../../assets/banners/courses/arquitetura_neg/Banner_ARQUITETURA_DE_NEGÓCIOS_CONCEITOS_E_APLICABILIDADE.png";
import mob46 from "../../assets/banners/courses/arquitetura_neg/MobileDataARQUITETURADENEGÓCIOSCONCEITOSEAPLICABILIDADE.png";

import mul47 from "../../assets/banners/courses/cyberseguranca/Sem_nome_1170_275_px_1000_275_px.png";
import mob47 from "../../assets/banners/courses/cyberseguranca/MobileDataCYBERSEGURANÇAEATAQUESHACKERS.png";

import mul48 from "../../assets/banners/courses/arquitetodenegocios/Desc_arquitetos_de_negocios_profissao_do_futuro-06.png";
import mob48 from "../../assets/banners/courses/arquitetodenegocios/arqmob.png";

import mul49 from "../../assets/banners/courses/dataAnalytics/Card_Data_Analytics.png";
import mob49 from "../../assets/banners/courses/dataAnalytics/CardDataAnalytics.png";

import mul50 from "../../assets/banners/courses/A_Tecnoliga_do_futuro/Banner_a_tecnologia_do_futuro-06.png";
import mob50 from "../../assets/banners/courses/A_Tecnoliga_do_futuro/Mobile_a_tecnologia_do_futuro-13.png";

import mul51 from "../../assets/banners/courses/Governe_sua_empresa/Banner_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT-06.png";
import mob51 from "../../assets/banners/courses/Governe_sua_empresa/Mobile_Governe_sua_empresa_através_dos_padrões_e_boas_práticas_de_ITIL_e_COBIT.png";

import mul52 from "../../assets/banners/courses/Arqnegicio_conceitos_apllic/Banner_arquitetura_de_negocio.png";
import mob52 from "../../assets/banners/courses/Arqnegicio_conceitos_apllic/Mobile_arquitetura_de_negocio.png";

import mul53 from "../../assets/banners/courses/Archimate/BannnerARCHIMATE.png";
import mob53 from "../../assets/banners/courses/Archimate/MobileARCHIMATE.png";


export default class CalendarPage extends Component {
  constructor() {
    super();
    const month = new Date();
    //
    this.state = {
      date: "Selecione uma data",
      data: [],
      selectedCourse: [],
      selectedCourseIndex: "0",
      selectedDay: 0,
      url: "",
      scheduleData: [],
      initialMonth: month.getMonth() + 1,
      showModal: false,
    };
    this.onClickDate = this.onClickDate.bind(this);
    this.onChangeMonth = this.onChangeMonth.bind(this);
  }

  componentWillMount() {
    this.setState({
      data: data,
      selectedCourse: this.props.match.params.id,
      selectedCourseIndex: this.props.match.params.index,
      scheduleData: dataSchedule,
    });
  }

  getArticle() {
    const data = this.state.data.conteudo;
    this.selectedCourseIndex = this.state.selectedCourseIndex;

    data.forEach((resp, index) => {
      if (resp[0].index === this.selectedCourseIndex) {
        return this.setArticle(resp);
      }
    });
  }

  setArticle(resp) {
    const selectedCourse = this.state.selectedCourse;
    resp.forEach((article, index) => {
      if (article.id === selectedCourse) {
        return (this.theArticle = article);
      }
    });
  }

  setDateSelected() {
    return <span>&nbsp;{this.state.date}</span>;
  }

  onClickDate(date, day) {
    document.querySelector(".BarOfIndication").style.display = "none";

    const list = this.theArticle.schedule;

    for (let index = 0; index < list.length; index++) {
      let phat = list[index].shift();
      let ruft = phat.split("/");
      let myDay = Number(ruft[0]);
      if (myDay === day) {
        this.i = list[index].pop();
      }
    }

    this.setState({
      selectedDay: day,
      date: date,
      url: this.i,
    });
  }

  onlyCurrentMonth() {
    const data = this.state.scheduleData.scheduleAll;

    const currentMonth = data.filter((month) => {
      const currentMonth = this.state.initialMonth;
      if (Number(month.month) === currentMonth) {
        return month;
      }
      return null;
    });
    return currentMonth;
  }

  onChangeMonth(monthSelected) {
    const month = monthSelected + 1;
    this.setState({
      initialMonth: month,
    });
  }

  renderBarIndication(article) {
    const dates = article;
    console.log(dates);
    return (
      <div className="BarOfIndication">
        <h4>DIAS DISPONÍVEIS</h4>
        <div className="BarInterneOfIndication">
          {dates.map((date) => {
            return <strong>{date[0]}</strong>;
          })}
        </div>
      </div>
    );
  }

  renderContent(article) {
    // const scheduleData = this.onlyCurrentMonth()
    return (
      <div>
        <article className="left calendar-container">
          <CalendarCustom
            schedule={article.schedule}
            selectedDay={this.state.selectedDay}
            onClickDate={this.onClickDate}
            onChangeMonth={this.onChangeMonth}
          />
          {this.renderBarIndication(this.theArticle.schedule)}
        </article>
        <aside>
          <ul>
            <li>
              Local:
              <span className="line">
                <i className="fa fa-caret-right"></i> {article.local}
              </span>
            </li>
            <li>
              Duração:
              <span className="line">
                <i className="fa fa-caret-right"></i> {article.duringTime}
              </span>
            </li>
            {/* <li>
              Valor:
              <span className='line'><i className="fa fa-caret-right"></i> R$ {article.value}</span>
            </li> */}
            <li>
              Data de início:
              <span className="line">
                <i className="fa fa-caret-right"></i>
                {this.setDateSelected()}
              </span>
            </li>
            {console.log(this.state.url)}
          </ul>
          <a
            href=""
            className="button primary-color"
            onClick={this.onClickReserve}
            choosedlocal={article.local}
            duringtime={article.duringTime}
            money={article.value}
            target="_blank"
          >
            Reservar este!
          </a>
        </aside>

        {/* <Schedule scheduleAll={scheduleData} propsHistory={this.props.history}/> */}
      </div>
    );
  }

  onClickReserve = (e) => {
    e.preventDefault();

    const choosedLocal = e.target.getAttribute("choosedlocal");
    const duringTime = e.target.getAttribute("duringtime");
    const money = e.target.getAttribute("money");
    const showModal = true;
    let modalAction;

    if (this.state.date === "Selecione uma data") {
      modalAction = "alert";
      return this.setState({ showModal, modalAction });
    } else {
      window.open(this.state.url);
    }

    modalAction = "reserve";

    this.setState({ duringTime, choosedLocal, money, showModal, modalAction });
  };

  openModal = () => {
    // const {duringTime, choosedLocal, money, date} = this.state
    const name = this.state.modalAction;
    let toRender;

    switch (name) {
      case "success":
        toRender = (
          <Modal closeModal={this.closeModal} customClass="success alignC">
            <h2>
              Mensagem enviada com sucesso! Aguarde, vamos entrar em contato com
              você em breve.
            </h2>
            <div className="alignC">
              <a className="button success" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      case "fail":
        toRender = (
          <Modal closeModal={this.closeModal} customClass="fail">
            <h2>
              Não foi possível enviar sua mensagem, por favor, tente novamente.
            </h2>
            <div className="alignC">
              <a className="button warning" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      case "alert":
        toRender = (
          <Modal closeModal={this.closeModal} customClass="alignC">
            <h2>Favor escolher uma data antes de reservar.</h2>
            <div className="alignC">
              <a className="button success" onClick={this.closeModal}>
                Ok
              </a>
            </div>
          </Modal>
        );
        break;
      case "reserve":
        // toRender = (
        //   <Modal closeModal={this.closeModal} customClass='reserve-form'>
        //     <h2>Olá, você escolheu:</h2>
        //     <p>O curso <span>{this.theArticle.title}</span> a ser realizado na <span>{choosedLocal}</span>, dia <span>{date}</span>, com <span>{duringTime}</span> de duração, no valor de <span>R$ {money}.</span>
        //     </p>
        //     <p>Para confirmar, favor preencher os campos abaixo e enviar o formulário.</p>
        //     <form
        //       id='form'
        //       action=''
        //       method='post'
        //       className='clear'
        //       onSubmit={this.submitForm}>
        //       <input
        //         name='formName'
        //         type='text'
        //         id='Nome'
        //         placeholder='Nome'
        //         required
        //         onChange={(e) => this.onChangeInputValue(e)}
        //       />
        //       <input
        //         name='formEmail'
        //         type='text'
        //         id='email'
        //         placeholder='E-mail (ex. meunome@meudominio.com)'
        //         pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
        //         required
        //         onChange={(e) => this.onChangeInputValue(e)}
        //       />
        //       <input
        //         name='formPhone'
        //         type='number'
        //         id='fone'
        //         placeholder='Telefone'
        //         required
        //         onChange={(e) => this.onChangeInputValue(e)}
        //       />
        //       <button type='submit' className='button' name='Submit'>
        //         Enviar
        //       </button>
        //     </form>
        //   </Modal>
        // )
        break;
      default:
        this.setState({ modal: false });
    }

    return toRender;
  };

  onChangeInputValue(e) {
    const inputInfo = e.target.name;
    const value = e.target.value;

    this.setState({
      [inputInfo]: value,
    });
  }

  submitForm = (e) => {
    e.preventDefault();

    const curseName = this.theArticle.title;
    const {
      duringTime,
      choosedLocal,
      money,
      date,
      formPhone,
      formEmail,
      formName,
    } = this.state;
    const formContent = {
      to_name: "Hit-Bra",
      from_name: formName,
      reply_to: formEmail,
      phone_number: formPhone,
      during_time: duringTime,
      choosed_local: choosedLocal,
      money_value: money,
      choosed_date: date,
      curse_name: curseName,
    };

    emailjs
      .send(
        "hit_bra_web",
        "template_reserve",
        formContent,
        "user_O6eWJvDwZo3yKsl0Y4H2I"
      )
      .then(
        (response) => {
          this.clearForm();
          this.onSuccessFormSubmit();
        },
        (error) => {
          this.onFailFormRequest();
        }
      );
  };

  clearForm = () => {
    document.getElementById("form").reset();
    this.setState({
      formName: "",
      formEmail: "",
      formPhone: "",
      formMsg: "",
    });
  };

  onSuccessFormSubmit = () => {
    const modalAction = "success";
    const modal = true;

    this.setState({ modal, modalAction });
  };

  onFailFormRequest = () => {
    const modalAction = "fail";
    const modal = true;

    this.setState({ modal, modalAction });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  /**
   * Retorna <img> relacionada ao curso com a imagem já adicionada em 'src'
   */

  returnImg(index) {
    var width = window.innerWidth;

    if (index === 1) {
      if (width > 700)
        return <img alt="1" src={mul1} className="course-image" />;
      return <img alt="1" src={mob1} className="course-image" />;
    } else if (index === 2) {
      if (width > 700)
        return <img alt="2" src={mul2} className="course-image" />;
      return <img alt="2" src={mob2} className="course-image" />;
    } else if (index === 3) {
      if (width > 700)
        return <img alt="3" src={mul3} className="course-image" />;
      return <img alt="3" src={mob3} className="course-image" />;
    } else if (index === 4) {
      // if (width > 700)
      return <img alt="4" src={mul4} className="course-image" />;
      // return <img alt="4" src={mob4} />
    } else if (index === 5) {
      if (width > 700)
        return <img alt="5" src={mul5} className="course-image" />;
      return <img alt="5" src={mob5} className="course-image" />;
    } else if (index === 6) {
      if (width > 700)
        return <img alt="6" src={mul6} className="course-image" />;
      return <img alt="6" src={mob6} className="course-image" />;
    } else if (index === 7) {
      if (width > 700)
        return <img alt="7" src={mul7} className="course-image" />;
      return <img alt="7" src={mob7} className="course-image" />;
    } else if (index === 8) {
      if (width > 700)
        return <img alt="8" src={mul8} className="course-image" />;
      return <img alt="8" src={mob8} className="course-image" />;
    } else if (index === 9) {
      if (width > 700)
        return <img alt="9" src={mul9} className="course-image" />;
      return <img alt="9" src={mob9} className="course-image" />;
    } else if (index === 12) {
      if (width > 700)
        return <img alt="12" src={mul12} className="course-image" />;
      return <img alt="12" src={mob12} className="course-image" />;
    } else if (index === 13) {
      if (width > 700)
        return <img alt="13" src={mul13} className="course-image" />;
      return <img alt="13" src={mob13} className="course-image" />;
    } else if (index === 14) {
      if (width > 700)
        return <img alt="14" src={mul14} className="course-image" />;
      return <img alt="14" src={mob14} className="course-image" />;
    } else if (index === 15) {
      if (width > 700)
        return <img alt="15" src={mul15} className="course-image" />;
      return <img alt="15" src={mob15} className="course-image" />;
    } else if (index === 16) {
      if (width > 700)
        return <img alt="16" src={mul16} className="course-image" />;
      return <img alt="16" src={mob16} className="course-image" />;
    } else if (index === 17) {
      if (width > 700)
        return <img alt="17" src={mul17} className="course-image" />;
      return <img alt="17" src={mob17} className="course-image" />;
    } else if (index === 17) {
      if (width > 700)
        return <img alt="18" src={mul18} className="course-image" />;
      return <img alt="18" src={mob18} className="course-image" />;
    } else if (index === 20) {
      if (width > 700)
        return <img alt="20" src={mul20} className="course-image" />;
      return <img alt="20" src={mob20} className="course-image" />;
    } else if (index === 21) {
      if (width > 700)
        return <img alt="21" src={mul21} className="course-image" />;
      else return <img alt="21" src={mob21} className="course-image" />;
    } else if (index === 22) {
      if (width > 700)
        return <img alt="22" src={mul22} className="course-image" />;
      else return <img alt="22" src={mob22} className="course-image" />;
    } else if (index === 23) {
      if (width > 700)
        return <img alt="23" src={mul23} className="course-image" />;
      else return <img alt="23" src={mob23} className="course-image" />;
    } else if (index === 24) {
      if (width > 700)
        return <img alt="24" src={mul24} className="course-image" />;
      else return <img alt="24" src={mob24} className="course-image" />;
    } else if (index === 25) {
      if (width > 700)
        return <img alt="25" src={mul25} className="course-image" />;
      else return <img alt="25" src={mob25} className="course-image" />;
    } else if (index === 26) {
      if (width > 700)
        return <img alt="26" src={mul26} className="course-image" />;
      else return <img alt="26" src={mob26} className="course-image" />;
    } else if (index === 27) {
      if (width > 700)
        return <img alt="27" src={mul27} className="course-image" />;
      else return <img alt="27" src={mob27} className="course-image" />;
    } else if (index === 28) {
      if (width > 700)
        return <img alt="28" src={mul28} className="course-image" />;
      else return <img alt="28" src={mob28} className="course-image" />;
    } else if (index === 29) {
      if (width > 700)
        return <img alt="29" src={mul29} className="course-image" />;
      else return <img alt="29" src={mob29} className="course-image" />;
    } else if (index === 30) {
      if (width > 700)
        return <img alt="30" src={mul30} className="course-image" />;
      else return <img alt="30" src={mob30} className="course-image" />;
    } else if (index === 35) {
      if (width > 700)
        return <img alt="35" src={mul35} className="course-image" />;
      else return <img alt="35" src={mob35} className="course-image" />;
    } else if (index === 38) {
      if (width > 700)
        return <img alt="38" src={mul38} className="course-image" />;
      else return <img alt="38" src={mob38} className="course-image" />;
    } else if (index === 49) {
      if (width > 700)
        return <img alt="30" src={mul49} className="course-image" />;
      else return <img alt="30" src={mob49} className="course-image" />;
    } else if (index === 50) {
      if (width > 700)
        return <img alt="50" src={mul50} className="course-image" />;
      else return <img alt="50" src={mob50} className="course-image" />;
    } else if (index === 51) {
      if (width > 700)
        return <img alt="51" src={mul51} className="course-image" />;
      else return <img alt="51" src={mob51} className="course-image" />;
    } else if (index === 52) {
      if (width > 700)
        return <img alt="52" src={mul52} className="course-image" />;
      else return <img alt="52" src={mob52} className="course-image" />;
    } else if (index === 53) {
      if (width > 700)
        return <img alt="53" src={mul53} className="course-image" />;
      else return <img alt="53" src={mob53} className="course-image" />;
    }
  }

  /**
   * Retorna a imagem relacionada ao curso
   */

  returnFigure(index) {
    var width = window.innerWidth;
    switch (index) {
      case "1":
        return mul1;

      case "2":
        return mul2;

      case "3":
        return mul3;

      case "4":
        return mul4;

      case "5":
        return mul5;

      case "6":
        return mul6;

      case "7":
        return mul7;

      case "8":
        return mul8;

      case "9":
        return mul9;

      case "12":
        return mul12;

      case "13":
        return mul13;

      case "14":
        return mul14;

      case "15":
        return mul15;

      case "16":
        return mul16;

      case "17":
        return mul17;
      case "18":
        return mul18;
      case "19":
        return mul19;
      case "20":
        return mul20;
      case "21":
        if (width > 700) return mul21;
        return mob21;

      case "22":
        if (width > 700) return mul22;
        return mob22;

      case "23":
        if (width > 700) return mul23;
        return mob23;

      case "24":
        if (width > 700) return mul24;
        return mob24;

      case "25":
        if (width > 700) return mul25;
        return mob25;

      case "26":
        if (width > 700) return mul26;
        return mob26;

      case "27":
        if (width > 700) return mul27;
        return mob27;

      case "28":
        if (width > 700) return mul28;
        return mob28;

      case "29":
        if (width > 700) return mul29;
        return mob29;

      case "30":
        if (width > 700) return mul30;
        return mob30;

      case "31":
        if (width > 700) return mul31;
        return mob31;

      case "32":
        if (width > 700) return mul32;
        return mob32;

      case "33":
        if (width > 700) return mul33;
        return mob33;

      case "34":
        if (width > 700) return mul34;
        return mob34;

      case "35":
        if (width > 700) return mul35;
        return mob35;

      case "36":
        if (width > 700) return mul36;
        return mob36;

      case "37":
        if (width > 700) return mul37;
        return mob37;

      case "38":
        if (width > 700) return mul38;
        return mob38;

      case "39":
        if (width > 700) return mul39;
        return mob39;

      case "40":
        if (width > 700) return mul40;
        return mob40;

      case "41":
        if (width > 700) return mul41;
        return mob41;
      case "42":
        if (width > 700) return mul42;
        return mob42;

      case "43":
        if (width > 700) return mul43;
        return mob43;

      case "44":
        if (width > 700) return mul44;
        return mob44;

      case "45":
        if (width > 700) return mul45;
        return mob45;

      case "46":
        if (width > 700) return mul46;
        return mob46;

      case "47":
        if (width > 700) return mul47;
        return mob47;
      case "48":
        if (width > 700) return mul48;
        return mob48;
      case "49":
        if (width > 700) return mul49;
        return mob49;
      case "50":
        if (width > 700) return mul50;
        return mob50;
      case "51":
        if (width > 700) return mul51;
        return mob51;
      case "52":
        if (width > 700) return mul52;
        return mob52;
          case "53":
        if (width > 700) return mul53;
        return mob53;
      default:
        return null;
    }
  }

  render() {
    this.getArticle();
    const backURL = `/workshop-page/${this.state.selectedCourseIndex}/${this.state.selectedCourse}`;
    const backURLTwo = `/workshop`;
    return (
      <div>
        {this.state.showModal ? this.openModal() : null}
        <div id="workshop-page" className="clear relative">
          <div className="squad">
            {this.theArticle.index == 12 ||
            this.theArticle.index == 13 ||
            this.theArticle.index == 14 ||
            this.theArticle.index == 15 ||
            this.theArticle.index == 16 ||
            this.theArticle.index == 17 ||
            this.theArticle.index == 20 ||
            this.theArticle.index == 21 ||
            this.theArticle.index == 22 ||
            this.theArticle.index == 23 ||
            this.theArticle.index == 24 ||
            this.theArticle.index == 25 ||
            this.theArticle.index == 26 ||
            this.theArticle.index == 27 ||
            this.theArticle.index == 28 ||
            this.theArticle.index == 29 ||
            this.theArticle.index == 30 ||
            this.theArticle.index == 31 ||
            this.theArticle.index == 32 ||
            this.theArticle.index == 33 ||
            this.theArticle.index == 34 ||
            this.theArticle.index == 35 ||
            this.theArticle.index == 36 ||
            this.theArticle.index == 37 ||
            this.theArticle.index == 38 ||
            this.theArticle.index == 39 ||
            this.theArticle.index == 40 ||
            this.theArticle.index == 41 ||
            this.theArticle.index == 42 ||
            this.theArticle.index == 43 ||
            this.theArticle.index == 44 ||
            this.theArticle.index == 45 ||
            this.theArticle.index == 46 ||
            this.theArticle.index == 47 ||
            this.theArticle.index == 49 ||
            this.theArticle.index == 50 ||
            this.theArticle.index == 51 ||
            this.theArticle.index == 52 || 
            this.theArticle.index == 53 ?(
              <section
                className="top-section"
                style={{
                  backgroundImage:
                    "url(" + this.returnFigure(this.theArticle.index) + ")",
                }}
              >
                <a href={backURLTwo} className="back-anchor">
                  <p className="back-paragraph">
                    <i className="fa fa-chevron-left"></i>
                    Voltar
                  </p>
                </a>
              </section>
            ) : (
              <section
                className="top-section"
                style={{
                  backgroundImage:
                    "url(" + this.returnFigure(this.theArticle.index) + ")",
                }}
              >
                <a href={backURL} className="back-anchor">
                  <p className="back-paragraph">
                    <i className="fa fa-chevron-left"></i>
                    Voltar
                  </p>
                </a>
              </section>
            )}
            <Reservation
              area={this.theArticle.section}
              description={this.theArticle.title}
              modality={this.theArticle.modality}
              duration={this.theArticle.duringTime}
              disponibility={this.theArticle.disponibility}
              schedule={this.theArticle.schedule}
              bannerImage={this.returnImg(this.theArticle.index)}
            />
            {/* Componente de avise-nos */}
            <section className="warnme-section">
              <Warnme
                disponibility={this.theArticle.disponibility}
                description={this.theArticle.title}
              />
            </section>
          </div>
        </div>
        <div class="contact-simplefooter">
          <div className="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    window.scroll(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/components/workshop/calendar.js